<template>
  <div class="login-content">
    <div class="login-warp">
      <div class="login-form">
        <span class="login-form-title">数采系统管理中心 V2.0</span>
        <el-form :model="loginFormData" @keyup.enter.native="onSubmit">
          <el-form-item class="login-item">
            <el-input v-model="loginFormData.username"
              size="large"
              placeholder="登录用户名/手机"
              ref="username"
              autoComplete="on"
              :disabled="logining"
              :class="loginFormData.username ? 'is-actived' : ''">
              <!-- <template slot="prepend"><i class="fa fa-user"></i></template> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input type="password" v-model="loginFormData.password"
              size="large"
              placeholder="登录密码"
              ref="password"
              :disabled="logining"
              :class="loginFormData.password ? 'is-actived' : ''">
              <!-- <template slot="prepend"><i class="fa fa-lock"></i></template> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox class="pull-left" v-model="loginFormData.remember">记住登录状态</el-checkbox>
          </el-form-item>
          <el-form-item class="text-center">
            <el-button
              class="login-button"
              type="primary"
              v-loading="logining"
              :disabled="logining || !loginFormData.username || !loginFormData.password"
              @click="onSubmit"
              >登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="login-more" style="background-image: url('/img/bg-01.png');"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginFormData: {
        username: '',
        password: '',
        remember: '',
      },
      logining: false,
    };
  },
  computed: {
    isValidated() {
      return this.loginFormData.username && this.loginFormData.password && !this.logining;
    },
  },
  mounted() {
    // // 浏览器自动填充需要设置一下
    // setTimeout(() => {
    //   const evt = window.document.createEvent('HTMLEvents');
    //   evt.initEvent('input', false, true);
    //   this.$refs.username.$refs.input.dispatchEvent(evt);
    //   this.$refs.password.$refs.input.dispatchEvent(evt);
    // }, 500);
  },
  methods: {
    onSubmit() {
      if (!this.isValidated) {
        return;
      }
      this.logining = true;
      let _this = this
      this.$store.dispatch('Auth/Login', this.loginFormData).then(() => {
        _this.$router.push({ name: 'Home' });
      }).finally(() => {
        this.logining = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-content {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  .login-warp {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    flex-direction: row-reverse;
    .login-form {
      width: 355px;
      display: block;
      background-color: #f5f5f5;
      padding: 50px 50px;
      margin: 60px 60px 100px 60px;
      border-radius: 20px;
      .login-form-title {
        font-size: 30px;
        font-family: Poppins, sans-serif;
        line-height: 1.2;
        text-align: center;
        width: 100%;
        display: block;
        padding-bottom: 50px;
      }
      .login-button {
        font-size: 16px;
        padding: 0 20px;
        width: 100%;
        height: 50px;
        border-radius: 10px;
        line-height: 1.2;
        letter-spacing: 1px;
      }
    }
    .login-more {
      width: calc(100% - 580px);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
      z-index: 1;
    }
  }
}
</style>
